import React from "react";
import HideIcon from "../vectors/HideIcon";
import HideCancel from "../vectors/HideCancel";

interface CurationToggleButtonProps {
  photoHidden: boolean;
  primaryColor: string;
  handleClick: Function;
  handleToggle: Function;
  handleHideTooltip: Function;
}

const CurationToggleButton: React.FC<CurationToggleButtonProps> = ({
  photoHidden,
  primaryColor,
  handleClick,
  handleToggle,
  handleHideTooltip
}) => (
  <div id="hide-btn">
    <button
      data-toggle="tooltip"
      data-placement="bottom"
      onMouseEnter={() =>
        handleToggle("hide-btn", photoHidden ? "Unhide Photo" : "Hide Photo")
      }
      //@ts-ignore TODO: fix this
      onMouseLeave={handleHideTooltip}
      className="geo-icon-btn-styling"
      //@ts-ignore TODO: fix this
      onClick={handleClick}
    >
      {photoHidden ? (
        <HideIcon color={primaryColor} />
      ) : (
        <HideCancel color={primaryColor} />
      )}
    </button>
  </div>
);

export default CurationToggleButton;
